import React, { useEffect, useRef, useState } from "react";
import { Layout } from "antd";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom";

import { selectTableauToken, selectEnvironment, selectMenuItems } from "../store/selector";
import { Routes } from "../constant/routes";

const { Content } = Layout;

const StyledDiv = styled.div`
  width: 100%;
  height: 100%;
`;

const MainView = () => {
  const [url, setUrl] = useState("");
  const token = useSelector(selectTableauToken);
  const environment = useSelector(selectEnvironment);
  const menuItems = useSelector(selectMenuItems);
  const vizRef = useRef(null);
  const containerRef = useRef(null);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (menuItems?.MenuItems?.length) {
      const firstSubMenu = menuItems?.MenuItems?.[0]?.subMenus?.[0];

      // Handle both /insights and /insights/ cases for root path
      const isRootPath = location?.pathname === Routes.ROOT || location?.pathname === "/insights";
      const isSelectPath = location?.pathname?.endsWith(Routes.SELECT);

      // Redirect when path ends with Routes.SELECT or when on root path
      if (isSelectPath || isRootPath) {
        history.push({
          pathname: `${Routes.ROOT}${Routes.SELECT}${firstSubMenu?.title}`,
          state: { url: firstSubMenu?.url, title: firstSubMenu?.title }
        });
        setUrl(firstSubMenu?.url);
      }
    }
  }, [menuItems, location?.pathname]);

  useEffect(() => {
    setUrl(location?.state?.url);
  }, [location?.state?.url]);

  // Forcefully clear tableau-viz when url is empty
  useEffect(() => {
    if (!url && containerRef.current) {
      containerRef.current.innerHTML = "";
    }
  }, [url]);

  useEffect(() => {
    setUrl(location?.state?.url);
  }, [location?.state?.url]);

  useEffect(() => {
    if (vizRef.current) {
      const shadowRoot = vizRef.current.shadowRoot;
      if (shadowRoot) {
        const iframe = shadowRoot.querySelector("iframe");
        if (iframe) {
          iframe.style.width = "100%";
        }
      }
    }
  }, [vizRef.current]);

  return (
    <Content style={{ margin: "24px" }}>
      {environment && (
        <StyledDiv id="tableau-viz" ref={containerRef}>
          {url && (
            <tableau-viz id="viz-component" ref={vizRef} toolbar="true" token={token} src={url}>
              <viz-parameter name="TMSiteName" value={environment}></viz-parameter>
            </tableau-viz>
          )}
        </StyledDiv>
      )}
    </Content>
  );
};

export { MainView };
